/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { JobsJobWork } from '../models/jobs-job-work';
import { Envelope } from '../models/envelope';
import {Lookup} from '@models/lookup';
@Injectable({
  providedIn: 'root',
})
class JobWorkService extends __BaseService {
  static readonly JobWorkGetAllPath = '/api/jobwork';
  static readonly JobWorkUpdatePath = '/api/jobwork';
  static readonly JobWorkCreatePath = '/api/jobwork';
  static readonly JobWorkGetPath = '/api/jobwork/{id}';
  static readonly JobWorkDeletePath = '/api/jobwork/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  JobWorkGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<JobsJobWork[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobwork`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJobWork[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  JobWorkGetAll(): __Observable<Envelope<JobsJobWork[]>> {
    return this.JobWorkGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<JobsJobWork[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  JobWorkUpdateResponse(entity: JobsJobWork): __Observable<__StrictHttpResponse<Envelope<JobsJobWork>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/jobwork`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJobWork>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  JobWorkUpdate(entity: JobsJobWork): __Observable<Envelope<JobsJobWork>> {
    return this.JobWorkUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<JobsJobWork>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  JobWorkCreateResponse(entity: JobsJobWork): __Observable<__StrictHttpResponse<Envelope<JobsJobWork>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/jobwork`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJobWork>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  JobWorkCreate(entity: JobsJobWork): __Observable<Envelope<JobsJobWork>> {
    return this.JobWorkCreateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<JobsJobWork>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobWorkGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<JobsJobWork>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobwork/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJobWork>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobWorkGet(id: number): __Observable<Envelope<JobsJobWork>> {
    return this.JobWorkGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<JobsJobWork>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobWorkDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/jobwork/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobWorkDelete(id: number): __Observable<Envelope<any>> {
    return this.JobWorkDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }
}

module JobWorkService {
}

export { JobWorkService }
